export default __webpack_public_path__ + "static/media/nRefer.6c0f06df.svg";